import styled from "styled-components"

export const AddressList = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.greyLight};
  padding: 2rem 2rem;
  border-radius: 0.6rem;
  margin-bottom: 2rem;
`
